import { RectNode, RectNodeModel, h } from '@logicflow/core';
import { getThemeStyle } from '../theme';

class DataStoreReferenceView extends RectNode {
  getShape() {
    const { model } = this.props;
    const { x, y, width, height } = model;
    const style = model.getNodeStyle();

    const left = x - width / 2;
    const top = y - height / 2;
    const ry = 6; // ellipse vertical radius for cylinder cap

    // Cylinder shape: top ellipse + body + bottom ellipse
    const bodyPath = `M ${left} ${top + ry} L ${left} ${top + height - ry}`;
    const bottomArc = `A ${width / 2} ${ry} 0 0 0 ${left + width} ${top + height - ry}`;
    const rightSide = `L ${left + width} ${top + ry}`;
    const topArc = `A ${width / 2} ${ry} 0 0 0 ${left} ${top + ry}`;

    const outlinePath = `M ${left} ${top + ry} ${bodyPath.split(' ').slice(3).join(' ')} A ${width / 2} ${ry} 0 0 0 ${left + width} ${top + height - ry} L ${left + width} ${top + ry} A ${width / 2} ${ry} 0 0 0 ${left} ${top + ry} Z`;

    return h('g', {}, [
      // Body fill
      h('path', {
        d: `M ${left} ${top + ry} L ${left} ${top + height - ry} A ${width / 2} ${ry} 0 0 0 ${left + width} ${top + height - ry} L ${left + width} ${top + ry} A ${width / 2} ${ry} 0 1 1 ${left} ${top + ry} Z`,
        ...style,
      }),
      // Top ellipse (visible cap)
      h('ellipse', {
        cx: x,
        cy: top + ry,
        rx: width / 2,
        ry: ry,
        fill: style.fill,
        stroke: style.stroke,
        strokeWidth: style.strokeWidth,
      }),
    ]);
  }
}

class DataStoreReferenceModel extends RectNodeModel {
  initNodeData(data) {
    super.initNodeData(data);
    this.width = 50;
    this.height = 50;
  }

  getNodeStyle() {
    const style = super.getNodeStyle();
    const t = getThemeStyle(this.graphModel, 'dataStoreReference');
    style.stroke = t.stroke || '#555';
    style.strokeWidth = t.strokeWidth ?? 1.5;
    style.fill = t.fill || '#fff';
    return style;
  }
}

export const DataStoreReference = {
  type: 'epx:DataStoreReference',
  view: DataStoreReferenceView,
  model: DataStoreReferenceModel,
};
